import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    patientAddSubDocument,
    patientRemoveSubDocument,
    patientUpdateSubDocument,
    patientSetSubDocument,
} from '../../../service/api/patient-api';
import MedicationListPanel from '../medication-list/medication-list-panel';
import { resolveActingDoctorId } from '../../../utils/common-funtions/common';

export const PAST_MEDICATION_FIELD = 'pastMedications';

// Past Medication is stored on the PATIENT, so it follows the patient from visit to
// visit. This adapter owns the list and the patient sub-document writes; the list and
// drug-picker UI live in MedicationListPanel, shared with Current Medication.
const PastMedication = ({ visitDetails, patientDetails, updateState, patientId, headerSlot }) => {
    const { user, selectedRole, selectedDoctor } = useSelector((state) => state.auth);
    // Doctors act as themselves; assistants act on behalf of the selected doctor.
    const actingDoctorId = visitDetails?.doctor || resolveActingDoctorId({ user, selectedRole, selectedDoctor });

    const [pastMedicines, setPastMedicines] = useState([]);

    useEffect(() => {
        if (patientDetails?.pastMedications) {
            setPastMedicines(patientDetails.pastMedications);
        }
    }, [patientDetails]);

    const applyPatient = (patient) => {
        setPastMedicines(patient?.pastMedications || []);
        updateState(patient);
    };

    const addMedicine = (payLoad) =>
        patientAddSubDocument(PAST_MEDICATION_FIELD, payLoad, patientId)
            .then((res) => { if (res?.status === 200) applyPatient(res?.data); })
            .catch((error) => { console.log(error); });

    const deleteMedicine = (medicine) =>
        patientRemoveSubDocument(PAST_MEDICATION_FIELD, { _id: medicine?._id }, patientId)
            .then((res) => { if (res?.status === 200) applyPatient(res?.data); })
            .catch((error) => { console.log(error); });

    const updateField = (value, type, id) =>
        patientUpdateSubDocument({
            filterKey: `${PAST_MEDICATION_FIELD}._id`,
            filterKeyValue: id,
            payload: { [`${PAST_MEDICATION_FIELD}.$.${type}`]: value },
        }, patientId)
            .then((res) => { if (res?.status === 200) applyPatient(res?.data); })
            .catch((error) => { console.log(error); });

    const reorder = (sortedList) => {
        setPastMedicines(sortedList);
        patientSetSubDocument(PAST_MEDICATION_FIELD, sortedList, patientId)
            .then((res) => { if (res?.status === 200) applyPatient(res?.data); })
            .catch(() => { });
    };

    return (
        <MedicationListPanel
            title="Past Medication"
            fieldKey={PAST_MEDICATION_FIELD}
            items={pastMedicines}
            doctorId={actingDoctorId}
            visitId={visitDetails?._id}
            emptyText="No past medications added yet"
            // The sig form's edit path writes to the VISIT, which has no
            // pastMedications field — keep it closed here. See medicine-sig-form.jsx.
            enableSigEdit={false}
            headerSlot={headerSlot}
            onAdd={addMedicine}
            onDelete={deleteMedicine}
            onUpdateField={updateField}
            onReorder={reorder}
        />
    );
};

export default PastMedication;
